import { render } from "./SubHeaderBar.vue?vue&type=template&id=2b6c683c&scoped=true"
import script from "./SubHeaderBar.vue?vue&type=script&lang=js"
export * from "./SubHeaderBar.vue?vue&type=script&lang=js"

import "./SubHeaderBar.vue?vue&type=style&index=0&id=2b6c683c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6c683c"]])

export default __exports__